import { H1, H2, H3, H4, P2 } from '../../../styles/FontStyles';
import { Main, Section4TextWrapper, Section4Wrapper } from '../Home.styled';

import image from '../../../assets/images/sec4image.png';
import { colors, lightTheme } from '../../../styles/GlobalStyles';
import { Div, Img } from '../../../styles/Styles';
import { AnimatedDiv } from 'components/Animation/Animation';

const slides = [
  {
    title: 'Community-first approach: ',
    text: 'Learn, grow, and succeed together',
  },
  {
    title: 'Access to innovative, proven products',
    text: '',
  },
  {
    title: 'Transparent, ethical leadership with a proven track record',
    text: '',
  },
  {
    title: 'Support, training, and resources for all members',
    text: '',
  },
  {
    title: 'Global network and partnership opportunities',
    text: '',
  },
];

export const Section4 = () => {
  return (
    <Section4Wrapper id='section4'>
      <Main>
        <AnimatedDiv>
          <H2 center mb='130' mbSM='50' color={colors.white}>
            Join a Global Community Focused on Education, Innovation, and
            Long-Term Success.
          </H2>
        </AnimatedDiv>
        <AnimatedDiv $flex $center $columnSM $gap='150px' $gapSM='50px'>
          <Div $width='40%' $widthSM='100%'>
            <H3
              mb='50'
              centerSM
              color={lightTheme.white}
              fontFamily='Nulshock'
              fontSize='40px'
              lineHeight='110%'
            >
              Be among the first to secure your place with{' '}
              <span> United One </span>
            </H3>
            <Img src={image} width='100%' alt='section4' />
          </Div>
          <Div $width='60%' $widthSM='100%'>
            <H4 mb='30' centerSM color={lightTheme.white}>
              Why Join United One?
            </H4>
            <Div $flex $column $gap='10px'>
              {slides.map(({ title, text }) => (
                <Section4TextWrapper>
                  <svg
                    width='15'
                    height='15'
                    viewBox='0 0 15 15'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <circle cx='7.5' cy='7.5' r='7.5' fill='white' />
                  </svg>
                  <Div>
                    <P2 mb='0' color={lightTheme.white}>
                      <b>{title}</b>
                    </P2>
                    {text && (
                      <P2 mt='10' color={lightTheme.white}>
                        {text}
                      </P2>
                    )}
                  </Div>
                </Section4TextWrapper>
              ))}
            </Div>
          </Div>
        </AnimatedDiv>
      </Main>

      {/* <Section4Wrapper2>
        <Swiper
          className='mySwiper'
          loop={true}
          autoplay={{
            delay: 6000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
        >
          {slides.map(({ title, text, image }) => (
            <SwiperSlide>
              <Main>
                <Div $width='100%' $flex $alignCenter $gap='50px' $columnSM>
                  <Div $width='50%' $widthSM='100%'>
                    <H2 mb='30' right centerSM color={lightTheme.primary}>
                      {title}
                    </H2>
                    <P1 right centerSM color={lightTheme.white}>
                      {text}
                    </P1>
                  </Div>
                  <Div $width='50%' $widthSM='100%'>
                    <Img src={image} width='100%' alt={title} />
                  </Div>
                </Div>
              </Main>
            </SwiperSlide>
          ))}
        </Swiper>
      </Section4Wrapper2> */}

      {/* <Main>
        <Div $mt='130px'>
          <H2 center mb='30' color={colors.primary}>
            Introducing MyLife points <br /> Pay & Save!
          </H2>
          <Div $flex $center>
            <P1 maxWidth='900px' center mb='32' color={colors.white}>
              With other services, you pay for a subscription and keep
              spending—but with Travelution, you pay for access and save money!
              Every subscription grants you MyLife Points, which you can use to
              discount attractions, stays, and more.
            </P1>
          </Div>
        </Div>
      </Main> */}
    </Section4Wrapper>
  );
};
